import { makeAutoObservable } from "mobx";
import { isMobile } from "pixi.js";

class KeyboardStore {
  isOpen = false;
  keyBoardWrapperElement = null;
  activeInputElement = null;

  constructor() {
    makeAutoObservable(this);
  }

  open(inputElement) {
    if (!isMobile.phone) return;
    if (inputElement === this.activeInputElement) return;
    this.activeInputElement = inputElement;
    this.isOpen = true;

    setTimeout(() => {
      const scrollableDiv = document.getElementById("application-body");
      scrollableDiv.scrollTo(0, Math.max(0, this.activeInputElement.offsetTop - 30));
    }, 0);
  }

  close() {
    if (!isMobile.phone) return;
    this.activeInputElement.blur();
    this.activeInputElement = null;
    this.isOpen = false;
  }

  type(value) {
    const newValue = insertValue(
      this.activeInputElement.value,
      this.activeInputElement.selectionStart,
      this.activeInputElement.selectionEnd,
      value
    );

    const selectionStart = this.activeInputElement.selectionStart + 1;

    simulateInputChange(this.activeInputElement, newValue);

    requestAnimationFrame(() => {
      this.activeInputElement.selectionStart = selectionStart;
      this.activeInputElement.selectionEnd = selectionStart;
      this.activeInputElement.focus();
    });
  }

  typeBackspace() {
    const isSingleCharacterSelected = this.activeInputElement.selectionStart === this.activeInputElement.selectionEnd;
    if (!this.activeInputElement.selectionStart && isSingleCharacterSelected) return;

    const startSelectionDiff = isSingleCharacterSelected ? -1 : 0;

    const newValue = insertValue(
      this.activeInputElement.value,
      this.activeInputElement.selectionStart + startSelectionDiff,
      this.activeInputElement.selectionEnd,
      ""
    );
    const selectionStart = this.activeInputElement.selectionStart + startSelectionDiff;

    simulateInputChange(this.activeInputElement, newValue);

    requestAnimationFrame(() => {
      this.activeInputElement.selectionStart = selectionStart;
      this.activeInputElement.selectionEnd = selectionStart;
      this.activeInputElement.focus();
    });
  }
}

export const keyboardStore = new KeyboardStore();

const insertValue = (str, startIndex, endIndex, value) => {
  const before = str.slice(0, startIndex);
  const after = str.slice(endIndex);
  return before + value + after;
};

const simulateInputChange = (input, newValue) => {
  Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set.call(input, newValue);

  input.dispatchEvent(new Event("input", { bubbles: true }));
};
